/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent, ReactNode } from 'react';

import { DeviceModel } from '../../../core/device';
import { BrandingUiInfoKeys } from '../../../core/entities';
import { ServicesClientImpl } from '../../../core/interactors';
import { CursorManager } from '../../../core/navigation';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { GridGuideFooterProps } from './GridGuideFooterProps';

import './GridGuideFooter.scss';

const GridGuideFooter: FunctionComponent<GridGuideFooterProps> = (props): JSX.Element => {
    const services = new ServicesClientImpl();
    const {
        selectedChannelType: channelsTypeText,
        highlightId,
        optionsMessage: selectText,
        menuMessage,
    } = props;
    const { isChannelsServiceFail } = useTivoSelector((state: RootState) => state.gridGuide);
    const { value: mouseTrapValue } = useTivoSelector((state: RootState) => state.inputFactory);
    const { isSidebarNavigationMenuActive } = useTivoSelector(
        (state: RootState) => state.sidebarNavigationMenu,
    );

    const secondaryBranding = services.getAppUiImageByKey(
        BrandingUiInfoKeys.APP_ICONS.SECONDARY_BRANDING,
    );

    let showFooterTipText = selectText;
    if (DeviceModel.isWebOsPlatform() && CursorManager.isCursorAppeared()) {
        showFooterTipText = highlightId === mouseTrapValue ? selectText : '';
    }
    if (isSidebarNavigationMenuActive) showFooterTipText = '';

    const message: ReactNode = <>{menuMessage}</>;

    return (
        <div className="footer-container">
            <img
                className="footer-branding-icon"
                src={secondaryBranding?.imageUrl}
                data-testid="guide-footer-branding-icon"
            />
            <div className="footer-return-text" data-testid="guide-footer-return-text">
                {message}
            </div>
            <div className="footer-select-and-all-channels-text">
                {!isChannelsServiceFail ? (
                    <span data-testid="guide-footer-select-text">{showFooterTipText}</span>
                ) : null}
                <span className="footer-tip-text-bullet"></span>
                {!isChannelsServiceFail ? (
                    <span data-testid="guide-footer-all-channels-text">
                        {channelsTypeText?.toLowerCase()}
                    </span>
                ) : null}
            </div>
        </div>
    );
};

export default GridGuideFooter;
